export default __webpack_public_path__ + "static/media/prize-2-cn.f63f5d84.webp";